import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0.75rem 5rem;
  font-weight: 500;
  background-color: #f9fafa;
  border-radius: ${({ theme }) => theme.borderRadius.small};
`;

export const Label = styled.p`
  margin: 0;
  font-weight: 500;
`;

export const MembersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 0.5rem;
`;

export const Member = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  p {
    margin: 0;
  }
`;

export const OnlineTag = styled.div`
  width: 0.8rem;
  height: 0.8rem;
  background-color: ${({ theme }) => theme.colors.mediumGreen};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
`;
